import { IconCopy } from '@f_components/icons/IconCopy';
import { ThemeContext } from '@f_context/Theme_context';
import { UserContext } from '@f_context/User_context';
import { MyModal } from '@f_general/MyModal';
import stls from '@f_styles/components/header/HeaderModal.module.sass';
import { HashUtil } from '@f_utils/HashUtil';
import { headerUserCopyReferralLinkUtil } from '@f_utils/referral.util';
import { Button, Modal, TextField, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type ReferralModalProps = {
    open: boolean;
    handleClose: () => void;
};

const pulseColor = '#FF6B35';

const referralPointsConfig = [
    'common.referral.description_0',
    'common.referral.description_1',
    'common.referral.description_2',
];

export function ReferralModal({ open, handleClose }: ReferralModalProps) {
    const { t } = useTranslation();
    const { colors } = useContext(ThemeContext);
    const { userInfo } = useContext(UserContext);
    const [referralUrl, setReferralUrl] = useState<string | null>(null);

    useEffect(() => {
        if (userInfo?.email) {
            const referralHash = HashUtil.encode(userInfo.email);
            if (referralHash) {
                const referralUrl = `https://web.qwep.ru/registration/referral/${referralHash}`;
                setReferralUrl(referralUrl);
            } else {
                setReferralUrl(null);
            }
        } else {
            setReferralUrl(null);
        }
    }, [userInfo?.email]);

    const handleCopy = async () => {
        await headerUserCopyReferralLinkUtil(referralUrl, t);
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <MyModal className={stls.modalReferral}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '209px',
                        marginBottom: '16px',
                        position: 'relative',
                    }}>
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '150px',
                            height: '150px',
                            borderRadius: '50%',
                            background: colors.alpha,
                            opacity: 0.6,
                            filter: 'blur(50px)',
                            zIndex: -1,
                        }}
                    />
                    <img
                        src="/gift.png"
                        alt="Gift"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                        }}
                    />
                </div>

                <Typography variant="h5" style={{ textAlign: 'center', marginBottom: '8px' }}>
                    {t('common.referral.bonus_title')}
                </Typography>

                <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '16px' }}>
                    <div
                        style={{
                            width: '41px',
                            height: '47px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <img
                            src="/iphone.png"
                            alt="iPhone"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                            }}
                        />
                    </div>
                    <Typography variant="h6" style={{ color: pulseColor }}>
                        {t('common.referral.bonus_description')}
                    </Typography>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
                    {referralPointsConfig.map((item, idx) => (
                        <div key={item} style={{ display: 'flex', gap: '8px' }}>
                            <Typography style={{ color: colors.alpha }}>{idx + 1}.</Typography>
                            <Typography>{t(item)}</Typography>
                        </div>
                    ))}
                </div>

                <TextField
                    type="text"
                    disabled={true}
                    placeholder={referralUrl || ''}
                    value={referralUrl || ''}
                    fullWidth
                    sx={{
                        marginBottom: '8px',
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: `${colors.alpha} !important`,
                            },
                            '&.Mui-disabled fieldset': {
                                borderColor: `${colors.alpha} !important`,
                            },
                            '& input': {
                                color: `${colors.alpha} !important`,
                            },
                            '&.Mui-disabled input': {
                                color: `${colors.alpha} !important`,
                                WebkitTextFillColor: `${colors.alpha} !important`,
                            },
                        },
                    }}
                />

                <Button
                    variant="contained"
                    onClick={handleCopy}
                    disabled={!referralUrl}
                    fullWidth
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '4px',
                        padding: '13px',
                    }}>
                    <IconCopy />
                    {t('common.referral.copy_promocode')}
                </Button>
            </MyModal>
        </Modal>
    );
}
